/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Guide_Details_TabInputs */



/**
* | output |
* | --- |
* | "Guide Details" |
*
* @param {Knp_Manager_Guide_Details_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_guide_details_tab = /** @type {((inputs?: Knp_Manager_Guide_Details_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Guide_Details_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détails du guide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leitfadendetails")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dettagli della guida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подробности руководства")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalles de la guía")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("指南详情")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイドの詳細")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गाइड विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detalhes do guia")
	return /** @type {LocalizedString} */ ("Guide Details")
});